'use client';

import { c as _c } from "react/compiler-runtime";
import { useHideFooter } from '@/components/footer/hide-footer-context';
import React, { type ReactNode } from 'react';

/**
 * Client wrapper for the footer that conditionally hides it based on context.
 *
 * A screen that covers the phone, like a chat, hides the app's tabs; on a desktop it sits beside
 * them, so they stay. In a browser the footer of an app page is what offers the app in the header,
 * which stays on a desktop as well.
 */
export const FooterClientWrapper: React.FC<{
  children: ReactNode;
}> = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  const {
    hideFooter
  } = useHideFooter();
  if (hideFooter) {
    let t1;
    if ($[0] !== children) {
      t1 = <div className="hidden xl:contents">{children}</div>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== children) {
    t1 = <>{children}</>;
    $[2] = children;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};